// react core
import React, { useContext, useState, useEffect } from 'react';
import { useParams } from "react-router-dom";

// components
import AjaxSpinner from 'components/commons/ajax_spinner';

// confs
import conf from 'conf/ajax';

// utils
import { clone_object } from 'commons/utils';

// user settings
import { UserContext } from 'store/user_context';

export default function FollowButton()
{
    const user_data = useContext(UserContext);
    let load_datta = (_id) =>
    {
        return new Promise((resolve, reject) =>
        {
            fetch(conf.plone_site + conf.server.followers.replace('{id}', _id),
                conf.ajax_configuration_object)
                .then(res =>
                {
                    if(res.status !== 404) return res.json();
                    console.error('missing resource?');
                })
                .then(
                    (result) =>
                    {
                        console.log(result);
                        resolve(result);
                    },
                    (error) =>
                    {
                        reject(error);
                    }
                ).catch(err =>
                {
                    reject(err);
                });
        });
    }

    let handle_click = (evt, method) =>
    {
        evt.stopPropagation();
        evt.preventDefault();
        let data_obj = clone_object(conf.ajax_configuration_object);
        data_obj.method = 'POST';
        data_obj.body = JSON.stringify({action:method});
        fetch(conf.plone_site + conf.server.follow.replace('{id}', params.id), data_obj)
        .then(res => res.json())
        .then(function(json_data)
        {
            if(json_data.status === 'ok')
            {
                setFollowers(json_data.data);
            }
        }).catch(error => console.error('Error:', error));
    };

    const params = useParams();
    const [followers, setFollowers] = useState({followers:[], count:0});
    const [isLoaded, setIsLoaded] = useState(false);
    useEffect(() =>
    {
        let mounted = true;
        load_datta(params.id).then(result =>
        {
            if(mounted)
            {
                setIsLoaded(true);
                setFollowers(result.data);
            }
        }).catch(err =>
        {
            if(mounted) setIsLoaded(true);
        });
        return () => mounted = false; // cleanup function
    }, [params.id, user_data]);

    if (!isLoaded || user_data === null)
    {
        return <AjaxSpinner tyoe="inline"/>;
    }
    else
    {
        return (<>
                {!followers.followers.includes(user_data.username) && <button href="/" title="Enable email notifications" className="button button-small" onClick={(evt) => handle_click(evt, 'add')}><i className="fa-regular fa-bell"></i> Follow</button>}
                {followers.followers.includes(user_data.username) && <button href="/" title="Disable email notifications" className="button button-small button-discreet" onClick={(evt) => handle_click(evt, 'remove')}><i className="fa-regular fa-bell-slash"></i> Unfollow</button>}
                </>
        );
    }
};
